import type { WidgetDefinition } from '../WidgetDefinition';
import { faFlask } from '@fortawesome/pro-duotone-svg-icons/faFlask';
import type { BacktestWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';

class BacktestWidgetDefinition implements WidgetDefinition<BacktestWidgetModel, BacktestWidgetModel> {
    type = 'backtest' as const;
    nameKey = 'widgets::backtest::name' as const;
    roles = ['widgets::backtest'];
    icon = faFlask;
    category = 'widgets::categories::research' as const;
    isLocalOnly = true;
    defaultDimensions = { h: 0.6, w: 0.5, x: 0.25, y: 0.2 };

    toViewModel(widget: BacktestWidgetModel): BacktestWidgetModel {
        return { ...widget };
    }

    toContractModel(widget: BacktestWidgetModel): BacktestWidgetModel {
        return widget;
    }
}

export const backtestWidgetDefinition = new BacktestWidgetDefinition();
